var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwiftTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83268 17.7083C7.78869 17.7083 9.37435 16.1227 9.37435 14.1667C9.37435 12.2107 7.78869 10.625 5.83268 10.625C3.87667 10.625 2.29102 12.2107 2.29102 14.1667C2.29102 16.1227 3.87667 17.7083 5.83268 17.7083Z",
    stroke: "#4F5372",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41576 10.9795H4.76992C4.0793 13.0478 4.0793 15.2862 4.76992 17.3545H4.41576",
    fill: "#4F5372"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41576 10.9795H4.76992C4.0793 13.0478 4.0793 15.2862 4.76992 17.3545H4.41576",
    stroke: "#4F5372",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89453 10.9795C7.58516 13.0478 7.58516 15.2862 6.89453 17.3545",
    stroke: "#4F5372",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64453 15.5837V15.2295C4.71286 15.9201 6.9512 15.9201 9.01953 15.2295V15.5837",
    stroke: "#4F5372",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.64453 13.1039C4.71286 12.4133 6.9512 12.4133 9.01953 13.1039",
    stroke: "#4F5372",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 12.5C18.3333 15.725 15.725 18.3333 12.5 18.3333L13.375 16.875",
    stroke: "#4F5372",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66602 7.50033C1.66602 4.27533 4.27435 1.66699 7.49935 1.66699L6.62436 3.12533",
    stroke: "#4F5372",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.13 1.5804L18.255 2.8304C18.3765 2.87901 18.4737 3.02484 18.4737 3.15331V4.30609C18.4737 4.49706 18.3175 4.65331 18.1265 4.65331H11.8765C11.6855 4.65331 11.5293 4.49706 11.5293 4.30609V3.15331C11.5293 3.02484 11.6265 2.87901 11.748 2.8304L14.873 1.5804C14.9425 1.55263 15.0605 1.55263 15.13 1.5804Z",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4737 8.47287H11.5293V7.43121C11.5293 7.24023 11.6855 7.08398 11.8765 7.08398H18.1265C18.3175 7.08398 18.4737 7.24023 18.4737 7.43121V8.47287Z",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2227 7.08095V4.65039",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0781 7.08095V4.65039",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9336 7.08095V4.65039",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7891 7.08095V4.65039",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1816 8.47266H18.8205",
    stroke: "#4F5372",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0013 3.78483C15.289 3.78483 15.5221 3.55165 15.5221 3.264C15.5221 2.97635 15.289 2.74316 15.0013 2.74316C14.7137 2.74316 14.4805 2.97635 14.4805 3.264C14.4805 3.55165 14.7137 3.78483 15.0013 3.78483Z",
    fill: "#4F5372"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiftTransfer);
export default __webpack_public_path__ + "static/media/SWIFT-transfer.0ef945e903c7b0626c2d21f9c62960f8.svg";
export { ForwardRef as ReactComponent };